import Header from '../components/Header';
import Hero from '../components/Hero';
import WhyUs from '../components/WhyUs';
import Pricing from '../components/Pricing';
import Regions from '../components/Regions';
import Faq from '../components/Faq';
import Footer from '../components/Footer';
import usePageSeo from '../hooks/usePageSeo';
import { useCacheDebug } from '../hooks/useCacheDebug';
import { emergencyCacheCleanup } from '../services/api';
import { PAGE_SEO } from '../config/seo';

function Home() {
  usePageSeo(PAGE_SEO.home);
  const { cacheInfo, isVisible, handleClearCache, refreshCacheInfo } = useCacheDebug();

  return (
    <>
      <Header />
      <Hero />
      <WhyUs />
      <Pricing />
      <Regions />
      <Faq />
      <Footer />

      {/* Отладка кэша (только в режиме разработки) */}
      {isVisible && (
        <div style={{
          position: 'fixed',
          bottom: '20px',
          right: '20px',
          background: 'rgba(0,0,0,0.9)',
          color: 'white',
          padding: '15px',
          borderRadius: '8px',
          fontSize: '12px',
          fontFamily: 'monospace',
          zIndex: 9999,
          maxWidth: '300px'
        }}>
          <div style={{ marginBottom: '10px', fontWeight: 'bold' }}>🔍 Кэш отладка</div>

          {/* Общая статистика */}
          {cacheInfo._summary && (
            <div style={{
              marginBottom: '10px',
              padding: '8px',
              background: 'rgba(255,255,255,0.1)',
              borderRadius: '4px',
              fontSize: '11px'
            }}>
              <div>📊 Записей: {cacheInfo._summary.totalEntries}/{cacheInfo._summary.cacheLimit}</div>
              <div>💾 Память: {cacheInfo._summary.totalSizeKB} КБ</div>
              <div>⏰ TTL: {cacheInfo._summary.ttlMinutes} мин</div>
            </div>
          )}

          {/* Детали кэша */}
          {Object.entries(cacheInfo).map(([key, info]) => {
            if (key === '_summary') return null;
            return (
              <div key={key} style={{ marginBottom: '5px', fontSize: '11px' }}>
                <span style={{ color: info.isValid ? '#4ade80' : '#f87171' }}>
                  {key}: {info.age}s {info.isValid ? '✓' : '✗'} ({info.sizeKB} КБ)
                </span>
              </div>
            );
          })}
          <div style={{ display: 'flex', gap: '8px', marginTop: '10px' }}>
            <button
              onClick={handleClearCache}
              style={{
                background: '#dc2626',
                color: 'white',
                border: 'none',
                padding: '5px 10px',
                borderRadius: '4px',
                cursor: 'pointer',
                fontSize: '11px',
                flex: 1
              }}
            >
              Очистить кэш
            </button>
            <button
              onClick={() => {
                emergencyCacheCleanup();
                refreshCacheInfo();
              }}
              style={{
                background: '#f59e0b',
                color: 'white',
                border: 'none',
                padding: '5px 10px',
                borderRadius: '4px',
                cursor: 'pointer',
                fontSize: '11px',
                flex: 1
              }}
              title="Удалить 70% старых записей"
            >
              Экстренная очистка
            </button>
          </div>
        </div>
      )}
    </>
  );
}

export default Home;
